module.exports = __webpack_public_path__ + "static/morrow_street-d515a22e918eaf6425453ee24fb810e1.svg";